import { createSelector } from 'reselect'
import { getBaseTierOfferWithNoJoiningFee } from 'selectors/luxPlusSelectors'
import { getLuxPlusBonusRequestOfferId } from '@luxuryescapes/lib-lux-loyalty'

export const getLuxPlusSubscriptionInflowPointsCalculationOptions = createSelector(
  (state: App.State) => state.auth.account.luxPlus.member.subscription.item,
  (state: App.State) => getBaseTierOfferWithNoJoiningFee(state),
  (subscriptionItem, baseTierOfferNoFee): App.LoyaltyPointsEarnCalculationRequest | undefined => {
    const price = baseTierOfferNoFee?.price ?? 0

    if (
      !baseTierOfferNoFee?.id ||
      price <= 0
    ) return

    return {
      price,
      loyaltyProductType: 'lux_plus',
      offerId: getLuxPlusBonusRequestOfferId(baseTierOfferNoFee.id, !!subscriptionItem?.isWithinRenewalGracePeriod),
      packageId: '',
    }
  },
)

export const getPointsCalculationsByKeys = createSelector(
  (state: App.State) => state.loyalty.pointsEarnCalculations,
  (_state: App.State, pointCalculationKeys: Array<string>) => pointCalculationKeys,
  (pointsCalculator, keys): Array<App.StatefulData<App.LoyaltyPointsEarnCalculation> | undefined> => keys.map(key => pointsCalculator[key]),
)
